export const licences: Record<string, string> = {
  Licences: 'Licencek',
  Devices: 'Eszközök',
  'Issue online licence': 'Online licenc kiadása',
  Plan: 'Csomag',
  Seats: 'Eszközhelyek',
  'Devices per member': 'Eszközök felhasználónként',
  Expiry: 'Lejárat',
  'Grace days': 'Türelmi napok',
  'Check-in days': 'Ellenőrzési napok',
  'Offline grace days': 'Offline türelmi napok',
  'Customer reference': 'Ügyfélhivatkozás',
  'Issue licence': 'Licenc kiadása',
  'Activation code': 'Aktiválási kód',
  'Active devices': 'Aktív eszközök',
  'Licensed devices': 'Licencelt eszközök',
  'Organisation admin': 'Szervezeti admin',
  'Create organisation': 'Szervezet létrehozása',
  'Organisation name': 'Szervezet neve',
  'Allowed company email domains (optional)': 'Engedélyezett vállalati e-mail domainek (opcionális)',
  'Save organisation': 'Szervezet mentése',
  'Show deleted organisations': 'Törölt szervezetek megjelenítése',
  'Delete organisation': 'Szervezet törlése',
  Device: 'Eszköz',
  User: 'Felhasználó',
  'Lease valid until': 'Licencbérlet érvényes',
  'Last check-in': 'Utolsó ellenőrzés',
  'Release seat': 'Eszközhely felszabadítása',
  'Company email': 'Vállalati e-mail',
  'Send invitation': 'Meghívó küldése',
  'Active company accounts': 'Aktív vállalati fiókok',
  'Invitation history': 'Meghívási előzmények',
  Sent: 'Elküldve',
  'Create company': 'Vállalat létrehozása',
  Revoked: 'Visszavont',
  Disabled: 'Letiltott',
  Member: 'Tag',
  'Licence issued.': 'Licenc kiadva.',
  'Enterprise licence issued.': 'Enterprise licenc kiadva.',
  'Organisation updated.': 'Szervezet frissítve.',
  'Organisation created.': 'Szervezet létrehozva.',
  'Organisation deleted.': 'Szervezet törölve.',
  'Device seat released.': 'Eszközhely felszabadítva.',
  'Invitation sent.': 'Meghívó elküldve.',
  'Stored/replacement required': 'Tárolt/cserélendő kód',
  'Activation-code licence': 'Aktiválókódos licenc',
  Accepted: 'Elfogadva',
  Expires: 'Lejár',
  'Type the organisation name to confirm:': 'A megerősítéshez írja be a szervezet nevét:',
  'This logically deletes the organisation, revokes all licences and releases active devices. User login accounts are retained.':
    'A művelet logikailag törli a szervezetet, visszavonja az összes licencet és felszabadítja az aktív eszközöket. A felhasználói bejelentkezések megmaradnak.',
  'Could not load data.': 'Az adatok betöltése sikertelen.',
  'Could not issue licence.': 'A licenc kiadása sikertelen.',
  '0 = no access for this channel. Existing usage cannot exceed the new limit.':
    '0 esetén nincs hozzáférés. A korlát nem lehet kisebb a foglalt helyek számánál.',
  Configured: 'Beállítva',
  'Delete this revoked licence?': 'Törli a visszavont licencet?',
  'Do you want to release this device seat?': 'Felszabadítja az eszközhelyet?',
  'Mobile invitations create app membership only. Web administrators are managed under Admin users.':
    'A mobilmeghívó csak alkalmazáshozzáférést ad. A webes hozzáférés a Webes felhasználók oldalon kezelhető.',
  'Mobile seats': 'Mobil felhasználóhelyek',
  'Mobile:': 'Mobil:',
  'Release device seat': 'Eszközhely felszabadítása',
  'Revoked licence deleted.': 'A visszavont licenc törölve.',
  'Web seats': 'Webes felhasználóhelyek',
  'reserved /': 'foglalt /',
  '· Web:': '· Web:',
  'Superadministrator must configure limits.': 'A felhasználóhelyek korlátját a szuperadminisztrátor állítja be.',
};
